<category-component></category-component>
<div class="container-fluid product-lisitng-wrapper" [ngClass]="{'fixed-header-height' : isFirstRow}"  *ngFor="let recommendation of recommendedProducts; let isFirstRow=first">
    <div class="heading">
        Recommended Products 
    </div>
    <div *ngIf="contentLoaded && !noRecord">

        <ng-container >
            <div class="recommended-product-main"  >
                
                <div class="customer-details">
                    <div class="name-and-details">
                        <div class="col-md-2 p-0">
                            <img *ngIf="recommendation.salesrep_image" src="{{profileImagePath}}{{recommendation.salesrep_image}}" alt="{{recommendation.sales_rep_name}}">
                            <img *ngIf="!recommendation.salesrep_image" src="../../../../assets/images/Group-742a.png" alt="{{recommendation.sales_rep_name}}">
                        </div>
                        <div class="title-main">
                        {{recommendation.recommendation_name}} | <b>{{recommendation.sales_rep_name}}</b>
                        <p>Products ({{recommendation.total_products}})</p>
                    </div>
                    </div>
                    <div class="contnet">
                        {{recommendation.recommendation_message}}
                    </div>
                </div>
        
        
                <div class="recommended-grid-main">
                    <div class="recommended-box" *ngFor="let product of recommendation.products">
                        <div class="image-box">
                            <div class="left-image">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="" width="100%">
                            </div>
                            <div class="right-contnet">
                            <div class="title"><span class="climp-css">{{product.short_desc}}</span> <span>({{product.unit_size}})</span></div>
                            <div class="small-div">
                                <div class="cost left" *ngIf="global_data?.price_visibility == 1">
                                    <p>Cost</p>
                                    <b>£{{product.price}}</b>
                                </div>
                                <div class="cost">
                                    <p>Case</p>
                                    <b>{{product.size_case}}</b>
                                </div>
                                <div class="cost left">
                                    <p>RSP</p>
                                    <b class="text-dark"><span *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                        <span *ngIf="product.rsp == '0.00'">N/A</span>  
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per 100g</span>
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                                    </b> 
                                </div>
                                <div class="cost" *ngIf="global_data?.margin_visibility == 1">
                                    <p>Margin</p>
                                    <b class="text-dark"> {{product.margin}}%</b>
                                </div>
                            </div>
                            </div>
                        </div>
            
                        <div class="button-box">
                            <span class="pmp-box" *ngIf="product.price_marked == 1">
                                <img
                    src="../../assets/images/pmp.svg" alt="checked icon" />
                            </span>
                        </div>
            
                        <div class="details-button">
                            <p class="first">PC: {{product.sku}}</p>
                            <p class="first">BC: {{product.barcode}}</p>
                        </div>
            
                        <div class="button-bottom">
                          
                        <div class="add-cart-wrapper w-100 add_btn_{{product.product_id}}" ng-app="classApp"
                            [ngClass]="product.item_id !== '' ? 'expand' : 'no-expand'">
                           
                            <div class="right-column suggested-col">

                                <div class="col-md-6 p-0">
                                    <button class="not-intrested"
                                    [ngClass]="{'btn not-interested':true}" *ngIf="product.item_id == ''"
                                    id="notinterestbtn_{{product.product_id}}__{{recommendation.recommend_id}}" 
                                    (click)="notInteretedSuggest(product, recommendation.recommend_id)">Not Interested</button>
                                </div>
                                <div class="col-md-6 pl-0 text-right mt-2">
                                <button class="add "
                                [ngClass]="{'add':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                                id="btn_{{product.product_id}}" *ngIf="product.item_id == '' && miniCartDetails.items_count != 0"
                                (click)="addToCart(product, product.qty, '', 'common', commonTemplate, recommendation.recommend_id)">Add</button>
                                <button  class="add "
                                    [ngClass]="{'add':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                                    id="btn_{{product.product_id}}" *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
                                    (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate, recommendation.recommend_id)">Add</button>

                                <p  class="out-of-stock" *ngIf="product.back_in_stock == '0'" >Out of Stock
                                </p>

                                <div class="mt-2" id="spinner_{{product.product_id}}">
                                    <ngx-number-spinner id="spinerbtn_{{product.product_id}}" *ngIf="product.item_id != ''"
                                        [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                        [value]="toInteger(product.qty)" [min]="0" 
                                        (change)="qytChange(product, $event, commonTemplate, recommendation.recommend_id)">
                                    </ngx-number-spinner>
                                </div>
                            </div>
                            </div>
                        </div>
                    
                        </div>
            
                    </div>

                </div>
            </div>
        </ng-container>
    </div>
   

</div>

<div class="container-fluid product-lisitng-wrapper fixed-header-height" >

<div class="row no-result" *ngIf="contentLoaded && noRecord">
    <div class="col-12">
        <div class="no-result-content">
            <img src="../../assets/images/no-result.svg" alt="no-result">
            <p>No Products Found</p>
            <span>No more recommendation available </span>
        </div>
    </div>
</div>

<div class="row no-result" *ngIf="!contentLoaded && noRecord">
    <div class="col-12">
        <div class="no-result-content">
            <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
            <p>Loading...</p>
        </div>
    </div>

</div>
</div>

<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>Please change the store if you want to create an order for another store.</p>
          </div>
          <div class="button-success text-center mt-3">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>
        
          </div>
        </div>
      </div>
    </div>
  </ng-template>

<ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>{{popupMessage}} </p>
          </div>
          <div class="button-div text-center mt-3 align-items-center">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>